import React from 'react';

import AutoComplete from 'material-ui/AutoComplete';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton/IconButton';
import Visibility from 'material-ui/svg-icons/action/visibility';

import api from 'services';

class PortsAutoComplete extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ports: [],
        };

        this.onUpdateInput = this.onUpdateInput.bind(this);
        this.onChooseAutoComplete = this.onChooseAutoComplete.bind(this);
    }

    onUpdateInput(searchText) {
        this.props.onChangePortFromAutoComplete({ name: searchText });


        if (searchText.length <= 2) {
            return;
        }

        api.findPortAdmin({ name: searchText })
            .then((response) => {
                if (response.status === 200) {
                    const ports = [];

                    response.data.data.forEach((item) => {
                        ports.push({
                            name: `${item.name} (${item.country ? item.country.name : ''})`,
                            item: (<MenuItem
                                primaryText={`${item.name} (${item.country ? item.country.name : ''})`}
                                item={item}

                            />),
                        });

                        if (item.sub && item.sub.length > 0) {
                            item.sub.forEach((subPort) => {
                                ports.push({
                                    name: `${subPort.name} (${item.country ? item.country.name : ''})`,
                                    item: (<MenuItem
                                        style={{ padding: '0 0 0 20px' }}
                                        primaryText={`${subPort.name} (${item.country ? item.country.name : ''})`}
                                        item={subPort}

                                    />),
                                });
                            })
                        }
                    });

                    this.setState({
                        ports,
                    }, () => {
                        document.body.scrollTop = document.body.scrollTop + 1;
                        document.body.scrollTop = document.body.scrollTop - 1;

                        const { selectedArea } = this.props;
                        selectedArea.isAddPort = false;
                        this.props.onChangeArea(selectedArea);
                    });
                }
            });

    }

    onChooseAutoComplete(updateProperties) {
        let portName = null;

        if (typeof updateProperties === 'string') {
            return;
        }

        portName = updateProperties.item.props.item.name;

        this.setState({
            canShow: false,
            selectedPort: updateProperties.item.props.item,
            portName,
            ports: [],
        }, () => {
            const { selectedArea } = this.props;
            selectedArea.isAddPort = true;
            this.props.onChangeArea(selectedArea);
            this.props.onChangePortFromAutoComplete(updateProperties.item.props.item);
        });
    }

    render() {
        const { ports } = this.state;
        const { portFromAutoComplete, showPort } = this.props;

        return (
            <div className='paper-block margin-10'>
                <span className='name-block absolute small-name'>Ports Auto Complete</span>
                <div className="middle-xs" style={{ display: 'flex' }}>

                    <AutoComplete
                        floatingLabelText='Port name'
                        searchText={portFromAutoComplete.name}
                        dataSource={ports}
                        dataSourceConfig={{ text: 'name', value: 'item' }}
                        onUpdateInput={this.onUpdateInput}
                        onNewRequest={this.onChooseAutoComplete}
                        filter={AutoComplete.noFilter}
                        style={{ width: '100%' }}
                        listStyle={{ maxHeight: '300px', overflow: 'auto' }}
                        fullWidth
                        popoverProps={{
                            canAutoPosition: true,
                            anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                            targetOrigin: { horizontal: 'left', vertical: 'top' },
                        }}
                    />
                    <IconButton
                        disabled={ portFromAutoComplete._id ? false : true }
                        onClick={() => {  showPort(portFromAutoComplete, false); }}>
                        <Visibility />
                    </IconButton>
                </div>
            </div>
        );
    }
}

export default PortsAutoComplete;



// WEBPACK FOOTER //
// ./app/components/Regions/Dashboard/Ports/PortsAutoComplete.jsx